export default {"src":"/_next/static/media/tokenomics_graph.faeb3759.svg","height":333,"width":355,"blurWidth":0,"blurHeight":0};